/* eslint-disable no-undef */
(function (window) {
    "use strict";
    function defineCustomerService() {
        let customerService = {};
        customerService.exportCustomersAsCsv = function (request) {
            return axios.post("/api/CustomerService/ExportCustomersAsCsv", request, { responseType: 'blob' });
        };
        customerService.getCustomerPeople = function (request) {
            return axios.post("/api/CustomerService/GetCustomerPeople", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
            });
        };
        customerService.getCustomerPerson = function (personId) {
            return axios.get("/api/CustomerService/GetCustomerPerson?personId=" + personId).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
            });
        };
        customerService.updateCustomerPerson = function (request) {
            return axios.post("/api/CustomerService/UpdateCustomerPerson", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        customerService.markCustomerPersonAsActiveOrInActive = function (request) {
            return axios.post("/api/CustomerService/MarkCustomerPersonAsActiveOrInActive", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
            });
        };
        customerService.deactivateCustomerPersonCard = function (request) {
            return axios.post("/api/CustomerService/DeactivateCustomerPersonCard", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
            });
        };
        customerService.issueNewCardToCustomerPerson = function (request) {
            return axios.post("/api/CustomerService/IssueNewCardToCustomerPerson", request).then(response => {
                return response;
            }).catch(error => {
                console.log("error", error);
                apiResponseHandlerHelepr.displayResponseMessageBasedOnApiResponseCodes(error.response.status, error.response.data.supportCode);
                return error.response;
            });
        };
        return customerService;
    }
    //define globally if it doesn't already exist
    if (typeof (customerService) === "undefined") {
        window.customerService = defineCustomerService();
    } else {
        console.log("customerService already defined.");
    }
})(window);